import { useLeaveCourseMutation } from "@api/course";
import { useToastEffect } from "@hooks/hooks";
import { useTranslation } from "react-i18next";
import { ModalVariant, useModal } from "./index";

interface LeaveCourseModalProps {
  courseId: string;
  courseName: string;
  onLeaveSuccess?: () => void;
}

export function useLeaveCourseModal({
  courseId,
  courseName,
  onLeaveSuccess,
}: LeaveCourseModalProps) {
  const { t } = useTranslation(["coursePage", "toast", "commons"]);
  const { Modal, openModal: openLeaveCourseModal } = useModal();

  const [
    leaveCourse,
    { isError: leaveIsError, isSuccess: leaveSuccess, error: leaveError },
  ] = useLeaveCourseMutation();

  useToastEffect({
    isError: leaveIsError,
    isSuccess: leaveSuccess,
    error: leaveError,
    successMessage: t("coursePage.successLeave", {
      courseName,
      ns: "toast",
    }),
  });

  const handleLeaveCourse = async () => {
    await leaveCourse(courseId);
    if (onLeaveSuccess) {
      onLeaveSuccess();
    }
  };

  const ModalComponent = () => (
    <Modal
      title={t("modalLeaveCourse")}
      confirmVariant={ModalVariant.DESTRUCTIVE}
      onConfirmLabel={t("modalLeaveCourseConfirmLabel")}
      onConfirm={handleLeaveCourse}
      onCancelLabel={t("cancel", { ns: "commons" })}
      onCancel={() => {}}
    >
      {t("modalLeaveCourseContent")}
    </Modal>
  );

  return {
    LeaveCourseModal: ModalComponent,
    openLeaveCourseModal,
  };
}
